import React from "react";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import PasswordOutlinedIcon from "@mui/icons-material/PasswordOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const PublicMenu = (authToken) => [
  ...(authToken
    ? []
    : [
        {
          label: "sidebar.menu.home",
          type: "section",
          children: [
            {
              uri: "/user/signup",
              label: "sidebar.menu.signup",
              type: "nav-item",
              icon: <PersonAddAltIcon sx={{ fontSize: 20 }} />,
            },
            {
              uri: "/user/signin",
              label: "sidebar.menu.login",
              type: "nav-item",
              icon: <LoginIcon sx={{ fontSize: 20 }} />,
            },
            {
              uri: "/user/forgot-password",
              label: "sidebar.menuItem.forgetPassword",
              type: "nav-item",
              icon: <PasswordOutlinedIcon sx={{ fontSize: 20 }} />,
            },
            {
              uri: "/upgrade",
              label: "sidebar.menuItem.pricePlan",
              type: "nav-item",
              icon: <CreditCardIcon sx={{ fontSize: 20 }} />,
            },
          ],
        },
      ]),
];

export default PublicMenu;
